module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-ORANGE-CREAM.369e501.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-ORANGE-CREAM.gif
// module id = JhLk
// module chunks = 0